import React from 'react';

export const HomeLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
